import { useState, useRef } from 'react';

function useStateRef(initialValue) {
  const [state, setState] = useState(initialValue);
  const ref = useRef(state);

  const setValue = value => {
    const nextValue = typeof value === 'function' ? value(ref.current) : value;

    ref.current = nextValue;
    setState(nextValue);
  };

  return [state, setValue, ref];
}

export default useStateRef;
